import type {State} from 'src/reducers';
import {AnalyticsQuery} from 'src/utils/analytics-query';
import type {ClientEventType} from 'src/types/events';

import mapKeys from 'lodash/mapKeys';

import {isSmsEvent} from 'src/utils/events';


export function selectDefaultQuery(
  state: State,
): AnalyticsQuery | null | undefined {
  return state.report.defaultQuery;
}

export function getTrackingEvents(eventType?: ClientEventType): string[] {
  let types;
  if (eventType === 'message') {
    types = [
      'sent',
      'delivered',
      'opened',
      'clicked',
      'unsubscribed',
      'bounced',
      'marked_as_spam',
    ];
  } else if (eventType === 'survey') {
    types = [
      'sent',
      'delivered',
      'opened',
      'clicked',
      'responded',
      'unsubscribed',
      'bounced',
      'marked_as_spam',
    ];
  } else if (eventType && isSmsEvent(eventType)) {
    types = ['sent', 'delivered', 'responded', 'unsubscribed'];
  } else {
    types = [
      'sent',
      'delivered',
      'opened',
      'clicked',
      'responded',
      'unsubscribed',
      'bounced',
      'marked_as_spam',
    ];
  }

  return types;
}

// TODO (kyle): eventually we shouldnt need this
const plotPropMap = {
  bounce: 'bounced',
  click: 'clicked',
  open: 'opened',
  spamreport: 'markedAsSpam',
  unsubscribe: 'unsubscribed',
} as const;
export function standardizePlotPoint(
  plotPoint: Record<any, any>,
): Record<any, any> {
  return mapKeys(plotPoint, (value, key) => {
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly bounce: "bounced"; readonly click: "clicked"; readonly open: "opened"; readonly spamreport: "markedAsSpam"; readonly unsubscribe: "unsubscribed"; }'.
    const mappedKey = plotPropMap[key];
    return mappedKey ? mappedKey : key;
  });
}
